import PropTypes from 'prop-types'

const FeatureFlagEnabled = ({ isFeatureEnabled, children }) => {
  return isFeatureEnabled ? children : null
}

const { bool, oneOfType, arrayOf, node } = PropTypes
FeatureFlagEnabled.propTypes = {
  isFeatureEnabled: bool,
  children: oneOfType([arrayOf(node), node]),
}

export default FeatureFlagEnabled
